import { ApiError } from "../../../api/problem";
import { LabelRefused } from "./label";

/** The sentence (an `addDevice.*` key) for a claim that did not go through. */
export function claimErrorKey(e: unknown): { key: string; minutes?: number } {
  if (e instanceof LabelRefused) return { key: e.reason === "crc" ? "addDevice.labelCrc" : "addDevice.labelFormat" };
  if (e instanceof ApiError) {
    if (e.status === 403 && e.code === "claim_refused") return { key: "addDevice.refused" };
    if (e.status === 403) return { key: "addDevice.forbidden" };
    // The contract's 409s on a claim (vision-api POST /v1/devices/claim). A device already this account's answers
    // 200, so no 409 means "already added".
    if (e.status === 409 && e.code === "release_pending") return { key: "addDevice.releasePending" };
    if (e.status === 409 && e.code === "voucher_stale") return { key: "addDevice.voucherStale" };
    if (e.status === 429) return { key: "addDevice.locked", minutes: e.retryAfterMinutes ?? 15 };
    if (e.status === 503) return { key: "addDevice.edgeBusy" };
  }
  return { key: "addDevice.failed" };
}
